import { render, staticRenderFns } from "./CustomPaginationSuperCompact.vue?vue&type=template&id=7080419c&lang=pug&"
import script from "./CustomPaginationSuperCompact.vue?vue&type=script&lang=js&"
export * from "./CustomPaginationSuperCompact.vue?vue&type=script&lang=js&"
import style0 from "./CustomPaginationSuperCompact.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports